export default function isEqual(value, other) {
	//check for false value
	if (value && other) {
		//checking if both value and other are array type
		if (Array.isArray(value) && Array.isArray(other)) {
			if (value.length === other.length) {
				for (let i = 0; i < value.length; i++) {
					if (isEqual(value[i], other[i]) === false) return false //recursive call for array elements
				}
				return true
			} else {
				return false
			}
		} else if (value.constructor === Object && other.constructor === Object) {
			//checking if both 'value' and 'other' are Object type
			if (Object.keys(value).length === Object.keys(other).length) {
				if (
					Object.keys(value).length !== 0 &&
					Object.keys(other).length !== 0
				) {
					//check object is not empty
					for (let key in value) {
						if (Object.prototype.hasOwnProperty.call(other, key)) {
							if (isEqual(value[key], other[key]) === false) return false //recursive call for object properties
						} else {
							return false
						}
					}
				}
			} else {
				return false
			}
		} else if (value.constructor === String && other.constructor === String) {
			//typeof(new String('')) results object
			return value == other
		} else {
			return value === other
		}
		return true //if all test condition passes returns true
	}
	return value === other
}
